module.exports = __webpack_public_path__ + "img/icone-coracao.b63d9a5b.svg";